(function () {
  'use strict';

  var config = window.vmaxBinderPosSetConstraint;
  if (!config || !Array.isArray(config.candidates)) return;

  var endpoint = 'https://portal.binderpos.com/external/shopify/products/forStore';
  var originalFetch = window.fetch;
  var game = String(config.game || 'pokemon').toLowerCase();
  var resolvedSetName = '';

  function normalize(value) {
    var normalized = String(value || '').toLowerCase();

    if (typeof normalized.normalize === 'function') {
      normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return normalized
      .replace(/&amp;/g, '&')
      .replace(/[\u2010-\u2015:–—-]+/g, ' ')
      .replace(/[^a-z0-9&]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  var candidates = config.candidates.filter(function (candidate, index, allCandidates) {
    return candidate && allCandidates.indexOf(candidate) === index;
  });

  if (candidates.length) resolvedSetName = String(candidates[0]).toLowerCase();

  function replaceConstraintParameters(setName) {
    var url = new URL(window.location.href);
    var changed = false;

    if (url.searchParams.get('setNames') !== setName) {
      url.searchParams.set('setNames', setName);
      changed = true;
    }

    if (url.searchParams.get('game') !== game) {
      url.searchParams.set('game', game);
      changed = true;
    }

    if (changed) {
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    }
  }

  if (resolvedSetName) replaceConstraintParameters(resolvedSetName);

  function getUrl(input) {
    return typeof input === 'string' ? input : input && input.url;
  }

  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var url = getUrl(input);

      if (url === endpoint) {
        if (!init || !init.body || !resolvedSetName) {
          return Promise.reject(new Error('BinderPOS set request blocked: missing collection constraint'));
        }

        try {
          var requestData = JSON.parse(init.body);
          requestData.game = game;
          requestData.setNames = [resolvedSetName];
          var constrainedInit = Object.assign({}, init, { body: JSON.stringify(requestData) });
          return originalFetch.call(this, input, constrainedInit);
        } catch (error) {
          return Promise.reject(new Error('BinderPOS set request blocked: invalid request body'));
        }
      }

      return originalFetch.call(this, input, init);
    };
  }

  function findMatchingOption(select) {
    var options = Array.prototype.slice.call(select.options);
    var normalizedCandidates = candidates.map(normalize).filter(Boolean);
    var exactMatch = options.find(function (option) {
      var optionValue = normalize(option.value);
      var optionLabel = normalize(option.textContent);
      return normalizedCandidates.some(function (candidate) {
        return candidate === optionValue || candidate === optionLabel;
      });
    });

    if (exactMatch) return exactMatch;

    for (var i = 0; i < normalizedCandidates.length; i += 1) {
      var candidate = normalizedCandidates[i];
      if (candidate.length < 4) continue;

      var suffixMatches = options.filter(function (option) {
        var optionValue = normalize(option.value);
        var optionLabel = normalize(option.textContent);
        return optionValue.endsWith(candidate) || optionLabel.endsWith(candidate);
      });

      if (suffixMatches.length === 1) return suffixMatches[0];
    }

    return null;
  }

  function makeSelectReadOnly(select, title, markerAttribute, refreshSelection) {
    var wasLocked = select.disabled && select.getAttribute(markerAttribute) === 'true';

    select.disabled = true;
    select.setAttribute('aria-disabled', 'true');
    select.setAttribute(markerAttribute, 'true');
    select.setAttribute('title', title);

    if (refreshSelection && !wasLocked && window.jQuery && window.jQuery.fn && window.jQuery.fn.select2) {
      window.jQuery(select).trigger('change.select2');
    }

    var select2 = select.nextElementSibling;
    if (select2 && select2.classList.contains('select2')) {
      select2.setAttribute('aria-disabled', 'true');
      select2.setAttribute('title', title);
      select2.style.pointerEvents = 'none';
      select2.style.opacity = '0.75';
    }
  }

  function lockGameFilter() {
    var select = document.querySelector('.left-column.tag-filter select#game');
    if (!select || !select.options.length) return false;

    var normalizedGame = normalize(game);
    var matchingOption = Array.prototype.slice.call(select.options).find(function (option) {
      var optionValue = normalize(option.value);
      var optionLabel = normalize(option.textContent);
      return optionValue === normalizedGame || optionLabel.indexOf(normalizedGame) !== -1;
    });

    if (!matchingOption) return false;

    Array.prototype.forEach.call(select.options, function (option) {
      option.selected = option === matchingOption;
    });

    makeSelectReadOnly(
      select,
      config.gameLocked,
      'data-vmax-binder-game-locked',
      false
    );
    return true;
  }

  function lockSetFilter(select) {
    if (!select || !select.options.length) return false;

    var matchingOption = findMatchingOption(select);
    if (!matchingOption) return false;

    Array.prototype.forEach.call(select.options, function (option) {
      option.selected = option === matchingOption;
    });

    resolvedSetName = matchingOption.value;
    config.resolvedValue = resolvedSetName;
    replaceConstraintParameters(resolvedSetName);
    makeSelectReadOnly(
      select,
      config.setLocked,
      'data-vmax-binder-set-locked',
      true
    );

    return true;
  }

  function lockGeneratedFilters() {
    lockGameFilter();
    Array.prototype.forEach.call(
      document.querySelectorAll('.left-column.tag-filter select#setNames'),
      lockSetFilter
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    var observer = new MutationObserver(function () {
      lockGeneratedFilters();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    lockGeneratedFilters();

    document.addEventListener('change', function (event) {
      if (event.target && (event.target.id === 'setNames' || event.target.id === 'game')) {
        lockGeneratedFilters();
      }
    }, true);
  });
})();
